import { createFileRoute, Outlet, useMatch } from "@tanstack/react-router";
import { PortalBare } from "@/components/app/portal/shell/portal-bare";
import { PortalLayout } from "@/components/app/portal/shell/portal-layout";

export const Route = createFileRoute("/family-portal")({
  component: FamilyPortalRoute,
});

/** Everything under /family-portal sits in the portal's shell, which signs the reader in once. The
 * invitation page is the exception: it is opened from an emailed link by somebody who may not have
 * an account yet, so it gets the bare frame. */
function FamilyPortalRoute() {
  const inviting = useMatch({ from: "/family-portal/join/$token", shouldThrow: false });
  if (inviting) {
    return (
      <PortalBare kind="family">
        <Outlet />
      </PortalBare>
    );
  }
  return <PortalLayout kind="family" />;
}
